import AddPointDialog from './addPointDialog.container'

export default AddPointDialog